export interface PriceFigures {
    last: number | null;
    change: number | null;
}

export function priceFigures(
    points: readonly { t: Date; close: number }[],
    range: readonly [Date, Date]
): PriceFigures {
    const t0 = range[0].getTime();
    const t1 = range[1].getTime();
    const inRange = points.filter(p => {
        const t = p.t.getTime();
        return t >= t0 && t <= t1;
    });
    const last = points.length > 0 ? points[points.length - 1].close : null;
    if (inRange.length < 2) return { last, change: null };
    const first = inRange[0].close;
    const end = inRange[inRange.length - 1].close;
    return { last, change: first !== 0 ? end / first - 1 : null };
}
